import gql from 'graphql-tag';

export const REDEEM_VOUCHER_MUTATION = gql`
  mutation redeemVoucher(
    $code: String!
    $testatorId: ID!
    $paymentPlan: PaymentPlanEnum!
  ) {
    redeemVoucher(
      code: $code
      testatorId: $testatorId
      paymentPlan: $paymentPlan
    ) {
      success
      amount
      transactionId
    }
  }
`;

export const VERIFY_VOUCHER_QUERY = gql`
  query verifyVoucher($code: String!) {
    verifyVoucher(code: $code)
  }
`;
